__turbopack_context__.v({
  "dont-grow": "icons-module-scss-module__Wpj44W__dont-grow",
  "icon": "icons-module-scss-module__Wpj44W__icon",
  "icon-clear": "icons-module-scss-module__Wpj44W__icon-clear",
  "icon-dark": "icons-module-scss-module__Wpj44W__icon-dark",
  "icon-dark-stroke": "icons-module-scss-module__Wpj44W__icon-dark-stroke",
  "icon-default": "icons-module-scss-module__Wpj44W__icon-default",
  "icon-default-stroke": "icons-module-scss-module__Wpj44W__icon-default-stroke",
  "icon-external-link": "icons-module-scss-module__Wpj44W__icon-external-link",
  "icon-lg": "icons-module-scss-module__Wpj44W__icon-lg",
  "icon-light": "icons-module-scss-module__Wpj44W__icon-light",
  "icon-light-stroke": "icons-module-scss-module__Wpj44W__icon-light-stroke",
  "icon-md": "icons-module-scss-module__Wpj44W__icon-md",
  "icon-ml": "icons-module-scss-module__Wpj44W__icon-ml",
  "icon-primary": "icons-module-scss-module__Wpj44W__icon-primary",
  "icon-primary-stroke": "icons-module-scss-module__Wpj44W__icon-primary-stroke",
  "icon-social-share": "icons-module-scss-module__Wpj44W__icon-social-share",
  "no-hover-effect": "icons-module-scss-module__Wpj44W__no-hover-effect",
});
